export default {
  title: 'Plătește cu {{method}}',
  hint: 'Apasă butonul de mai jos și aprobă plata în fereastra {{method}}.',
  confirming: 'Se confirmă plata…',
  cancel: 'Anulează plata',
  unavailable: 'Această metodă de plată nu este disponibilă momentan. Alege alta.',
  approval_timeout:
    'Nu am primit niciun răspuns de la {{method}}. Dacă fereastra nu s-a deschis, verifică dacă ferestrele pop-up sunt permise, apoi încearcă din nou sau alege altă metodă de plată.',
};
